import * as React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { Redirect } from 'react-router-dom';
import Modal from '../modal/Modal';
import Button from '../button/Button';
import './FlightConfiormationModalContainer.css';
import i18n from 'i18n-react';

const propTypes = {
  visible: PropTypes.bool,
  closeModal: PropTypes.func
};

class FlightConfiormationModalContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isRedirect: false,
      urlRedirect: ''
    };
  }

  render() {
    const width = '380px';

    return (
      <Modal hideCloseButton={true} width={width} visible={this.props.visible}>
        <div className="text-center">
          <Row className="padding-eight-vertical-8">
            <Col>
              <i className="icon-error-outline timer-icon flight-confirmation-timer-icon" />
            </Col>
          </Row>
          <Row className="padding-eight-vertical-8 padding-bottom-none text-xxxl text-3 text-deep-cerulean">
            <Col>{i18n.translate('message.flightConfirm').toString()}</Col>
          </Row>
          <Row className="padding-eight-vertical-8 text-lg text-2 text-warm-grey">
            <Col data-test="inactivityErrorMessage">
              {i18n.translate('message.flightConfirmationProceed').toString()}
            </Col>
          </Row>
          <Row className="padding-eight-vertical-16 padding-bottom-none">
            <Col className="closeModalButton">
              <Button
                name="modalButton"
                onClick={this.props.toggleFlightConfirmationModal}
                disabled={false}
                background={'shamrock'}>
                {i18n.translate('label.proceed').toString()}
              </Button>
            </Col>
          </Row>
          <Row className="padding-eight-vertical-16 padding-bottom-none">
            <Col className="closeModalButton">
              <Button
                name="modalButton"
                onClick={this.props.closeModal}
                disabled={false}
                background={'warm-grey-two'}>
                {i18n.translate('label.back').toString()}
              </Button>
            </Col>
          </Row>
        </div>
        {this.state.isRedirect ? (
          <Redirect
            push
            to={{
              pathname: this.state.urlRedirect
            }}
          />
        ) : null}
      </Modal>
    );
  }
}

FlightConfiormationModalContainer.propTypes = propTypes;

export default FlightConfiormationModalContainer;



// WEBPACK FOOTER //
// ./src/components/flightConfirmationModal/FlightConfiormationModalContainer.jsx